import utils from './index.js';

/**
 * 获取微信签名
 * @param {*} url
 * @param {*} options
 */
function jsapiSign(url, options = {}) {
    return new Promise((resolve, reject) => {
        utils.http.get(url, options).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}



/**
 * 发送验证码
 *
 * @param {*} url
 * @param {*} [options={}]
 * @returns
 */
function sms(url, options = {}) {
    return new Promise((resolve, reject) => {
        utils.http.post(url, options).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}


export default {
    jsapiSign,
    sms,
}